import { Inicio } from "components/Inicio/Inicio";


const routesInicio = [
    {
        path: "/inicio",
        name: "Inicio",
        icon: "nc-icon nc-caps-small",
        component: <Inicio />,
        permissions: ['INICIO', '49_ADMIN'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
    },
]

export {
    routesInicio
}